import ForgotPassword from '../../Components/ForgotPassword';
import {connect} from 'react-redux';
import {savePassword, generateOtp, clearError} from '../../modules/auth';
import {open} from '../../modules/modal';

const mapStateToProps = (state, ownProps) => {
  const {auth = {}} = state;
  const {loading = false} = auth;
  return {
    loading,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    savePassword: (requestData) => dispatch(savePassword(requestData)),
    generateOtp: (requestData) => dispatch(generateOtp(requestData)),
    open: (modalType, entity_id, data) =>
      dispatch(open(modalType, entity_id, data)),
    clearError: () => dispatch(clearError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
